module.exports = __webpack_public_path__ + "img/withdraw-gray.1c000ec7.svg";